import React, { Component, Dispatch } from 'react';
import ProcessingActivity from '../activity-proccessing/processing-activity';
import Translator from '../../../../core/i18n';
import { Common } from '../../../../core/common';
import Moment from 'moment';
import { enrollmentStatus } from '../../../../models/enums/enrollmentStatus';
import { ActivityCompletionType } from '../../../../models/enums/activityCompletionType';
import { enrollmentAddActionLog } from '../../../../store/actions/enrollment';
import { launchElesson } from '../../../../store/actions/elesson';
import ProgressCircle from '../../../progress-circle/progress-circle';
import { IAction, IAppState } from '../../../../models/action/core';
import { connect } from 'react-redux';
import { Log } from 'ng2-logger';
import { getCourseContentsWeekActivitiesAction, SetUpdateInput } from '../../../../store/actions/coursePage';
import { SecurityContextType, SecurityPermissionType } from '../../../../core/SecurityContext';
import EdiText from 'react-editext';
import { ISignleActivityCard } from '../../../../models/components/single-activity-card';
import { CoursePageService } from '../../../../api/course-page-service';
import { UserType } from '../../../../models/pages/login.d';
import { IActivityCard } from '../../../../models/components/activity-card';
import * as Actions from '../../../../store/actions/coursePage';
import ReactGA from 'react-ga4';
import ProgressCircleStudent from '../../../progress-circle/progress-circle-student';
import Tooltip from '../../../tooltip/main';

let _common: Common;
const T = Translator.create();
const _logger = Log.create('assignment_add_modal');
const maxEditTextLength = 65;
const coursePageService = new CoursePageService();
const virtualclassbg = `${process.env.PUBLIC_URL}/images/virtualClassCard/virtualclass.png`;

export class Elesson extends Component<ISignleActivityCard> {

    public containerDiv: HTMLDivElement | null = null;

    public state = {
        editTextValue:
            this.props.activityCard!.name!.toString().length > maxEditTextLength
                ? this.props.activityCard!.name!.slice(0, maxEditTextLength).toString() + '...'
                : this.props.activityCard!.name!.toString(),
        editTextHandleValue: this.props.activityCard!.name!.toString(),
        nonWeeklyCourse: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1
    };
    constructor(props: any) {
        super(props);
        _common = new Common();
        Moment.locale(T.i18next.language);
        this.onClickfullScreen = this.onClickfullScreen.bind(this);
        this.afterSave = this.afterSave.bind(this);
    }

    public componentDidMount(): void {
        if (this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1) {
            this.setState({ nonWeeklyCourse: true })
        }
    }

    componentDidUpdate(prevProps: Readonly<ISignleActivityCard>, prevState: Readonly<{}>, snapshot?: any): void {
        if (this.props.courseContentTermWeeks !== prevProps.courseContentTermWeeks && this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1) {
            this.setState({ nonWeeklyCourse: true })
        }
    }

    public callBackElessonClick = () => {
        this.props.dispatch(launchElesson(
            this.props.activityCard!.activityId!,
            this.props.classId!,
            this.props.activityCard!.enrollmentId!
        ));
    }

    public clickViewComplete = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_VIEW_ELESSON_CLICKED',
            label: 'G_VIEW_ELESSON_CLICKED',
            nonInteraction: true,
        });
        this.props.dispatch(enrollmentAddActionLog(
            {
                ActivityCompletionType: ActivityCompletionType.View,
                ActivityId: this.props.activityCard!.activityId,
                EnrollmentId: this.props.activityCard!.enrollmentId,
                ClassId: this.props.classId
            }, this.callBackElessonClick));

    }

    triggerGetCoursContent = () => {
        if (this.props.coursePageClassId && this.props.coursePageActivityId) {
            this.props.dispatch(Actions.getCourseContentsWeekActivitiesAction(
                this.props.coursePageClassId,
                this.props.coursePageActivityId,
                false,
                0,
                1000,
                this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
                false,
                false,
                null,
                'contentWeekActivities',
                'get',
                false,
                this.props.activityFilters.sort!));
        }
    }

    getActivities = (filters: any) => {
        let hasFilters = filters.hasFilters;
        const weekOrUnitId = this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId;
        const param: IActivityCard = {
            actId: '',
            coursePageClassId: this.props.coursePageClassId,
            coursePageActivityId: this.props.coursePageActivityId,
            courseContentTermWeeks: this.props.courseContentTermWeeks,
            hasFilter: filters.hasFilter,
            activityFilters: filters,
            GetOnlyPassiveList: this.props.activityFilters.GetOnlyPassiveList ? this.props.activityFilters.GetOnlyPassiveList : false,
            weekOrUnitId: hasFilters ? '-1' : weekOrUnitId,
            courseContentMenuType: this.props.courseContentMenuType,
            sort: this.props.activityFilters.sort!,
            activeStatus: hasFilters ? this.props.activityFilters.statusFilter : null,
            courseContentWeekActivities: this.props.courseContentWeeksActivities
        };
        this.props.dispatch(Actions.SetTriggerGetActivities(param, undefined, "SetTriggerGetActivities", 'get', this.props.courseDefaultView, this.state.nonWeeklyCourse));
    }

    public onClickfullScreen(e: React.MouseEvent<HTMLElement, MouseEvent>) {
        if (e.currentTarget.textContent === 'fullscreen') {
            e.currentTarget.textContent = 'fullscreen_exit';
            if (e.currentTarget.parentElement) {
                // fullsize yap
                if (this.containerDiv) {
                    this.containerDiv.classList.remove('animated');
                }
                e.currentTarget.parentElement.classList.add('fullScreenSize');
                e.currentTarget.parentElement.classList.add('zoomIn');
            }
        } else if (e.currentTarget.textContent) {
            e.currentTarget.textContent = 'fullscreen';
            if (e.currentTarget.parentElement) {
                // kucult
                if (this.containerDiv) {
                    this.containerDiv.classList.add('animated');
                }
                e.currentTarget.parentElement.classList.remove('zoomIn');
                e.currentTarget.parentElement.classList.remove('fullScreenSize');
            }
        }
    }

    afterSave() {
        this.props.dispatch(getCourseContentsWeekActivitiesAction(
            this.props.coursePageClassId ? this.props.coursePageClassId : '0',
            this.props.coursePageActivityId ? this.props.coursePageActivityId : '0',
            this.props.weekOrUnitId !== '0',
            0,
            1000,
            this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
            false,
            false,
            null,
            'contentWeekActivities',
            'get', undefined,this.props.sortKey ?? "-"));
    }

    public handleSave = (name: any) => {
        if (this.props.activityCard?.activityId && this.props.activityCard?.name !== name) {
            this.props.dispatch(
                SetUpdateInput(this.props.activityCard.activityId, name, 'api/activity/updateActivityName', 'POST', this.props.classId!, this.afterSave)
            );
            this.setState({
                editTextValue: name.length > maxEditTextLength
                    ? name.slice(0, maxEditTextLength).toString() + '...'
                    : name.toString(), editTextHandleValue: name
            });
        }
    };

    public handleClick(value: string) {
        this.setState({ editTextValue: value });
    };

    checkPrerequisite = () => {
        let isPrerequisiteCompleted = false
        if (this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student) {
            if (this.props.enrollmentData) {
                let prerequisiteActivities = this.props.enrollmentData.filter(f => f.activityId === this.props.activityCard!.prerequisiteActivityId)
                if (prerequisiteActivities.length > 0) {
                    if (prerequisiteActivities[0].status === enrollmentStatus.Completed && this.props.userType === UserType.Student) {
                        isPrerequisiteCompleted = true;

                    }
                }

            }
        }
        return isPrerequisiteCompleted;
    }

    renderCardHeader = () => {
        let enrollmentData = this.props.enrollmentData!.filter(enr => enr.activityId === this.props.activityCard!.activityId);
        let enrollmentDataStatus = enrollmentData.length > 0 ? enrollmentData[0].status : enrollmentStatus.NotStarted
        let activityEnrollmentStatus = this.props.activityCard!.enrollmentStatus ? this.props.activityCard!.enrollmentStatus
            : enrollmentDataStatus;

        let activityDeadline = this.props.activityCard!.taskDeadLine ? this.props.activityCard!.taskDeadLine : null;

        return (
            <div className="card-header">
                <div className={"activity-title "+ (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? 'arabic-text-card' : '')}>
                    <img
                        src={_common.GetActivityTypeIcons('elesson')}
                        alt="Elesson Activity Icon"
                    />
                    {
                        Common.HasPermission(SecurityContextType.Class, SecurityPermissionType.Activity_Add, this.props.classId!) ? (
                            <div title={this.props.activityCard!.name} className="visible">
                                <EdiText
                                    type="text"
                                    onSave={this.handleSave}
                                    onCancel={event => this.handleClick(this.state.editTextValue.length > maxEditTextLength
                                        ? this.state.editTextValue.slice(0, maxEditTextLength).toString() + '...'
                                        : this.state.editTextValue.toString())}
                                    onEditingStart={event => this.handleClick(this.state.editTextHandleValue)}
                                    value={this.state.editTextValue}
                                    showButtonsOnHover={true}
                                    saveButtonClassName="hideEditextSaveButton"
                                    cancelButtonClassName="hideEditextCancelButton"
                                    validationMessage={T.t('r_forum_tree_character')}
                                    // tslint:disable-next-line:jsx-no-lambda
                                    validation={val => val.trim().length >= 3}
                                    editOnViewClick={true}
                                    submitOnEnter={true}
                                    cancelOnEscape={true}
                                    className={'font-weight-bold mobile-activity-title web-activity-title'+ (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}
                                />
                            </div>
                        ) : <div title={this.props.activityCard!.name} className={"visible mobile-activity-title web-activity-title" + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} tabIndex={0} style={{ cursor: 'pointer', lineHeight: 1.3, whiteSpace: 'pre-line', textOverflow: 'ellipsis' }}>{this.props.activityCard!.name}</div>
                    }

                    <ProcessingActivity
                        externalCssClassName="ml-auto show_on_mobile"
                        activityId={this.props.activityCard!.activityId}
                        activityType={this.props.activityCard!.activityType}
                    />

                </div>
                <div className="activity-status">
                {this.props.activityCard?.alwaysOnTop ? <span className="pinned"></span> : ''}
                <span className="badges badges-elesson activity-type">{T.t('r_activity_type_Elesson')}</span>
                    {/* <h6 style={{ margin: 'auto' }}>{this.props.activityCard?.alwaysOnTop ? '📍' : ''}</h6> */}
                    {this.props.activityCard!.taskDeadLine ? <div className="last-date" style={{ paddingRight: '20px' }} data-toggle="tooltip" data-placement="top" title={T.t('r_activity_deadline')}>
                       
                        <Tooltip data={T.t('r_activity_deadline') +': '+ Moment(this.props.activityCard!.taskDeadLine).format(
                            _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 3)
                                )} position='top' > <span><i className="material-icons mr-1 text-warning">calendar_today</i></span>
                        </Tooltip>
                    </div> : ''}
                    {this.props.userType === UserType.Student && this.props.activityCard!.enrollmentScore !== null && this.props.activityCard!.enrollmentScore !== undefined && this.props.activityCard!.enrollmentScore>=0 ? (
                        <div className="activity-spec" style={{ marginRight: '20px' }}>
                            <div className="spec-icon note-green"><img src={_common.GetDefaultIcons('aplus')} alt="" /></div>
                            <div className="spec-text">
                                <span className="spec-title" tabIndex={0}>{T.t('r_grade')}</span>
                                <span className="spec-title-bold" tabIndex={0}>{this.props.activityCard!.enrollmentScore}</span>
                            </div>
                        </div>
                    ) : null}
                    {Common.HasPermission(SecurityContextType.Class, SecurityPermissionType.Activity_Add, this.props.classId!) ? (
                        <ProgressCircle activityCard={this.props.activityCard} percent={this.props.activityCard!.completedUser === 0 ? 0 : ((this.props.activityCard!.completedUser! * 100) / this.props.activityCard!.totalEnrollUser!)} />
                    ) : (
                        <ProgressCircleStudent enrollmentStatus={activityEnrollmentStatus ?? enrollmentStatus.NotStarted} deadline={activityDeadline} activityCard={this.props.activityCard}/>
                    )}
                    &nbsp;
                    <ProcessingActivity
                        externalCssClassName="hide_on_mobile"
                        activityId={this.props.activityCard!.activityId}
                        activityType={this.props.activityCard!.activityType}
                    />
                </div>
            </div>
        )
    }

    renderDescription = () => {
        return (
            (this.props.activityCard!.description && _common.removeHtmlTags(this.props.activityCard!.description).length > 0 ) ? <><hr className="bottom-border-2 mobile-not-show " />
                <div className="row new-activity-padding mobile-not-show ">
                    <div className="col d-flex justify-content-start align-items-baseline new-activity-block" >
                        <img src={_common.GetDefaultIcons('infoicon')} className="mr-2" alt="" />
                        <p className="card-info-text card-info-text-width mobile-activity-description">
                            <b>{T.t('r_add_exam_teacher_note')}</b> <span id='instructor_note' className={(!_common.isArabic(this.props.activityCard!.description, document.body.getAttribute('dir')) ? 'arabic-text-direction' : '')} dangerouslySetInnerHTML={{ __html: this.props.activityCard!.description }} />
                        </p>
                    </div>
                </div></> : ''
        )
    }

    returnSubProgress = (progressValue: any) => {
        if (progressValue.length > 4) {
            let subCssProgress = progressValue.substring(0, 4);
            return subCssProgress.indexOf('%') > -1 ? subCssProgress : (subCssProgress + '%')
        }
        else return progressValue
    }

    public render() {
        let isCompletedPrerequisiteActivity: boolean = this.checkPrerequisite();

        let elessonProgressBarValue = '0';
        let elessonProgress = '0';

        if (this.props.userType === UserType.Student) {
            let progress = (this.props.activityCard!.enrollmentTotalSecond ? this.props.activityCard!.enrollmentTotalSecond! * 100 : 0) / this.props.activityCard!.completionCriteria! 
            if (progress >= 100) {
                elessonProgressBarValue = '100%';
            }
            else {
                elessonProgressBarValue = progress.toString() + '%';
            }
            elessonProgress = Moment.utc((this.props.activityCard!.enrollmentTotalSecond ? this.props.activityCard!.enrollmentTotalSecond : 0) * 1000).format('HH:mm:ss');
        }

        return (
            <div className="col-12 mobile-padding card-width">
                <div className={this.props.activityCard!.activeStatus === 0 ? 'card new-activity border-pasif' : 'card new-activity'}>
                    {this.renderCardHeader()}
                    <hr className="bottom-border-2" />
                    {!isCompletedPrerequisiteActivity && this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student ?
                        <div className='row' style={{
                            opacity: 0.5,flexDirection:'column',
fontSize:'1em !important',

                            alignItems:'center',
                            justifyContent:'center',
                            textAlign: 'center',
                        }}>
                            <i className="material-icons" style={{ fontSize: '96px', marginTop: '10px' }}>lock</i>
                            <h5 className="font-medium">
                                {T.t('r_activity_restriction_by_another_message').replace('{0}', this.props.activityCard!.name).replace('{1}', this.props.activityCard!.prerequisiteActivityName)}
                            </h5>
                        </div> :
                        <div className="card-body" style={{ padding: '0px 23px 0px 23px' }}>
                            <div className="row mx-0 ">
                                <div className="virtual-class-bg" style={{ backgroundImage: `url(${virtualclassbg})` }}>
                                    <div className="virtual-class-button">
                                        <button onClick={this.clickViewComplete} className="big-success-btn ">{T.t('r_view')}</button>
                                    </div>
                                </div>
                            </div>
                            {this.props.activityCard!.completionType === 12 && !Common.HasPermission(SecurityContextType.Class, SecurityPermissionType.Activity_Add, this.props.classId!) ?
                                <div className="row  d-flex align-items-center new-activity-padding mobile-not-show ">
                                    <div className="col-3">
                                        <span className="progress-bar-text">{T.t('r_activity_showed_time')}</span>
                                    </div>
                                    <div className="col-7">
                                        <div className="e-lesson-progress">
                                            <div className="progress">
                                                <div className="progress-bar" style={{ width: elessonProgressBarValue }} role="progressbar" aria-valuenow={this.props.activityCard!.enrollmentTotalSecond!} aria-valuemin={0} aria-valuemax={this.props.activityCard!.completionCriteria! ? this.props.activityCard!.completionCriteria! : 100} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-2 px-0 d-flex flex-column">
                                        <span className="progress-percent">{
                                        (this.props.activityCard?.completionCriteria! * 1000) < 0 ? '0%' : this.returnSubProgress(elessonProgressBarValue)}</span>
                                        <span className="progress-time"><b>{elessonProgress}</b>/{Moment.utc(this.props.activityCard!.completionCriteria! * 60 * 1000).format('HH:mm:ss')}</span>
                                    </div>
                                </div> : ''}
                            {this.renderDescription()}
                        </div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISignleActivityCard): ISignleActivityCard => {
    if (!state) {
        return ownProps;
    }
    const newProps: ISignleActivityCard = Object.assign({}, ownProps, {
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        enrollmentData: state.enrollment.enrollmentData,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        userType: state.login.identitiy.userType,
        activityFilters: state.coursePage.activityFilters,
        courseDefaultView: state.coursePage.courseDefaultView,
        sortKey: state.coursePage.courseSortingKey
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.enrollment.enrollmentData === prev.enrollment.enrollmentData &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.activityFilters === prev.coursePage.activityFilters &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.coursePage.courseDefaultView === prev.coursePage.courseDefaultView
    );
    return ret;
};


const CElesson = connect(
    mapStateToProps,
    dispatchProps, null, { areStatesEqual }
)(Elesson);

export default CElesson;
